// extracted by mini-css-extract-plugin
export default {"refreshButton":"logs_refreshButton__sCXvn","logsContainer":"logs_logsContainer__r6mw8","tabs":"logs_tabs__UKYCn","tabsContent":"logs_tabsContent__I+80s"};